import React from "react";
import { Footer, Text } from "rsuite";
import { useGlobalPersistentStore } from "../../store";

const FooterComponent = () => {
  const { loggedInUserDetails } = useGlobalPersistentStore();

  return (
    <Footer className="footer-container">
      <Text className="footer-text">@{"meghasmarttrading.in"}</Text>
      <Text className="footer-subtext">
        {loggedInUserDetails.username
          ? `You're logged in as ${loggedInUserDetails.username}. Enjoy your stay!`
          : `Please login to continue`}
      </Text>
    </Footer>
  );
};

export default FooterComponent;
